
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"512","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M544 512c141.385 0 256-114.615 256-256S685.385 0 544 0c-70.702 0-134.71 28.662-181.039 75H16C7.163 75 0 82.163 0 91v368c0 8.837 7.163 16 16 16h395.357c38.684 23.48 84.085 37 132.643 37z","fill":"#0A0A0A","fill-opacity":".4"}}),_c('g',{attrs:{"filter":"url(#filter0_b_39397_200427)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M788 256c0 134.757-109.243 244-244 244-67.975 0-129.458-27.796-173.703-72.643H20.031a8 8 0 01-8-8v-268a8 8 0 018-8H327.5C368.198 65.297 449.875 12 544 12c134.757 0 244 109.243 244 244z","fill":"#0A0A0A","fill-opacity":".4"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_b_39397_200427","x":"-7.092","y":"-7.124","width":"814.216","height":"526.247","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"BackgroundImageFix","stdDeviation":"9.562"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur_39397_200427"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_backgroundBlur_39397_200427","result":"shape"}})])])])
          )
        }
      }
    